import { render, staticRenderFns } from "./TicketPrintCard.vue?vue&type=template&id=2c821c8e&"
import script from "./TicketPrintCard.vue?vue&type=script&lang=js&"
export * from "./TicketPrintCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports